import script from "./paymentTab.vue?vue&type=script&setup=true&lang=js"
export * from "./paymentTab.vue?vue&type=script&setup=true&lang=js"

import "./paymentTab.vue?vue&type=style&index=0&id=75022fbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75022fbe"]])

export default __exports__